import { odooApi } from '../index';
import { getOdooLang } from '@/config/api.config';
import { extractErrorMessage } from '../transforms';

/**
 * Global Search API Endpoints
 * 
 * Searches across multiple content types: departments, events, news, tenders, facilities, talents, gulf_cup, partners
 */

export interface SearchResult {
  id: number;
  name?: string;
  title?: string;
  type: 'department' | 'event' | 'news' | 'tender' | 'facility' | 'talent' | 'gulf_cup' | 'partner';
  image?: string | null;
  website_slug?: string;
  code?: string;
  event_date?: string;
  date?: string;
  start_date?: string;
  end_date?: string;
  location?: string;
  status?: string;
  full_address?: string;
  host_country?: string;
}

export interface GlobalSearchResponse {
  success: boolean;
  data: {
    departments: SearchResult[];
    events: SearchResult[];
    news: SearchResult[];
    tenders: SearchResult[];
    facilities: SearchResult[];
    talents: SearchResult[];
    gulf_cup: SearchResult[];
    partners: SearchResult[];
  };
  total_results: number;
  query: string;
  language: string;
}

export const searchApi = odooApi.injectEndpoints({
  endpoints: (builder) => ({
    // Global search across all content types
    globalSearch: builder.query<GlobalSearchResponse, { q: string; lang?: 'ar' | 'en' | 'ku' }>({
      query: ({ q, lang = 'ar' }) => {
        const odooLang = getOdooLang(lang);
        
        return {
          url: `/api/moys/search?q=${encodeURIComponent(q)}&lang=${odooLang}`,
          method: 'POST',
        };
      },
      transformResponse: (response: any) => {
        try {
          if (!response.success) {
            throw new Error('Search failed');
          }
          
          return response as GlobalSearchResponse;
        } catch (error) {
          console.error('[Search API] Transform error:', error);
          throw error;
        }
      },
      transformErrorResponse: (response) => {
        return extractErrorMessage(response);
      },
      providesTags: ['Analytics'],
    }),
  }),
});

export const {
  useGlobalSearchQuery,
} = searchApi;
